import { render } from "./ReportsDoughnutChart.vue?vue&type=template&id=2394285e"
import script from "./ReportsDoughnutChart.vue?vue&type=script&lang=js"
export * from "./ReportsDoughnutChart.vue?vue&type=script&lang=js"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__